export var DRAG_AREA = {
  ALL: 'all',
  HANDLE: 'handle'
};
export var DRAG_HANDLE_VISIBILITY = {
  ALWAYS: 'always',
  HOVER: 'hover'
};